import { render } from "./Upload.vue?vue&type=template&id=46a7849f&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=46a7849f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46a7849f"

export default script